export default __webpack_public_path__ + "static/media/sync-solid.e9ec0d29.svg";